import React, { useState, useEffect } from "react";
import Style from "../styles/landing/LesvitaApp.module.scss";
import logoSrc from "../Assets/images/logo/claro.svg";
import { useNavigate } from 'react-router-dom';
import { useUser } from "../contexts/UserContext";
import Loader from '../design/components/Loader/Loader';

// Fundo, halo e logo grande: os MESMOS no carregamento e nas boas-vindas, no
// mesmo lugar, para a troca de um para o outro não mexer no logo.
const Fundo = () => (
  <>
    <span className={Style.fundo} aria-hidden="true" />
    <div className={Style.arte} aria-hidden="true">
      <span className={Style.halo} />
      <img className={Style.logo} src={logoSrc} alt="" draggable="false" />
    </div>
  </>
);

const LoadingScreen = () => (
  <main className={Style.tela}>
    <Fundo />
    <div className={Style.carregando}>
      <Loader tamanho={64} />
    </div>
  </main>
);

export default function LesvitaApp() {
  const navigate = useNavigate();

  const { currentUser, loading: authLoading } = useUser();

  const [view, setView] = useState('loading');

  // Trava o scroll do body/html enquanto esta tela (loading/welcome) está no ar
  // e devolve ao topo ao sair. A rota "/" aplica overflow:auto !important
  // (overflow-auto-route); sem isto, um arrasto aqui move o scroll do documento
  // e esse offset "vaza" para o dashboard, que aparece quebrado ao montar.
  // setProperty com "important" é necessário para vencer o !important da rota.
  useEffect(() => {
    const targets = [document.documentElement, document.body].filter(Boolean);
    targets.forEach((el) => el.style.setProperty("overflow", "hidden", "important"));
    return () => {
      targets.forEach((el) => el.style.removeProperty("overflow"));
      window.scrollTo(0, 0);
    };
  }, []);

  useEffect(() => {
    if (authLoading) {
      return; 
    }

    const timer = setTimeout(() => {
      if (currentUser) {
        navigate('/plataforma/pessoal', { replace: true });
      } else {
        setView('welcome');
      }
    }, 2000); 
    return () => clearTimeout(timer);

  }, [authLoading, currentUser, navigate]); 
  if (view === 'loading') {
    return <LoadingScreen />;
  }

  const handleAccess = () => navigate('/login');
  const handleCreate = () => navigate('/login?tab=cadastro');

  return (
    <main className={Style.tela}>
      <Fundo />
      <header className={Style.cabecalho}>
        <h1 className={Style.titulo}>Bem-vindo a LesVita!</h1>
        <p className={Style.apoio}>seus objetivos fitness com inteligência</p>
      </header>
      <div className={Style.espaco} />
      <footer className={Style.folha}>
        <span className={Style.puxador} aria-hidden="true" />
        <button type="button" className={`${Style.botao} ${Style.primario}`} onClick={handleAccess}>
          Acessar Conta
        </button>
        <button type="button" className={`${Style.botao} ${Style.secundario}`} onClick={handleCreate}>
          Criar Conta
        </button>
      </footer>
    </main>
  );
}